import React from 'react';
import './SectionsSidebar.css';
import { createHeroElements } from './Sections/Hero1';
import { createHeroElements as createHeroElements2 } from './Sections/Hero2';
import { createHeroElements as createHeroElements3 } from './Sections/Hero3';
import { createHeroElements as createHeroElements4 } from './Sections/Hero4';
import { createHeroElements as createHeroElements5 } from './Sections/Hero5';
import { createHeroElements as createHeroElements6 } from './Sections/Hero6';
import { createHeroElements as createHeroElements7 } from './Sections/Hero7';
import { createCheckoutElements } from './Sections/Checkout1';
import { createNavbarElements } from './Sections/Navbar1';
import { createNavbarElements as createNavbarElements2 } from './Sections/Navbar2';
import { createNavbarElements as createNavbarElements3 } from './Sections/Navbar3';
import { createFooterElements } from './Sections/Footer1';
import { createFooterElements as createFooterElements2 } from './Sections/Footer2';
import { createFooterElements as createFooterElements3 } from './Sections/Footer3';
import { createFooterElements as createFooterElements4 } from './Sections/Footer4';
import { createPricingElements } from './Sections/Pricing1';
import { createPricingElements as createPricingElements2 } from './Sections/Pricing2';
import { createPricingElements as createPricingElements3 } from './Sections/Pricing3';
import { createPricingElements as createPricingElements4 } from './Sections/Pricing4';
import { createFeaturesElements } from './Sections/Features1';
import { createFeaturesElements as createFeaturesElements2 } from './Sections/Features2';
import { createFaqElements } from './Sections/Faq1';
import { createFaqElements as createFaqElements2 } from './Sections/Faq2';
import { createFaqElements as createFaqElements3 } from './Sections/Faq3';
import { createBlogElements } from './Sections/Blog1List';
import { createBlog2Elements } from './Sections/Blog2List';
import { createBlog3Elements } from './Sections/Blog3List';
import { createTeamElements } from './Sections/Team1';
import { createTeamElements as createTeamElements2 } from './Sections/Team2';
import { createTeam3Elements } from './Sections/Team3';
import { createTestimonialElements } from './Sections/Testimonial1';
import { createTestimonialElements as createTestimonialElements2 } from './Sections/Testimonial2';
import { createContactElements } from './Sections/Contact1';
import { createContactElements as createContactElements2 } from './Sections/Contact2';

const SectionsSidebar = ({ 
  isOpen, 
  onClose, 
  selectedCategory, 
  setSelectedCategory,
  elements,
  setElements,
  currentPageId,
  setClassStylesRegistry,
  setGlobalClassNames,
  setSelectedElement,
  setNewlyAddedElement,
  showNotification,
  setShowSectionsSidebar
}) => {
  const handleSectionSelect = (section) => {
    if (!section || !section.sectionType) {
      showNotification("Invalid section template", "error");
      return;
    }

    const getHierarchyName = (elementType) => {
      const elementCount = elements.filter(el => el.type === elementType).length + 1;
      return `${elementType.charAt(0).toUpperCase() + elementType.slice(1)} ${elementCount}`;
    };

    if (section.sectionType === 'hero-1') {
      const { elements: heroElements } = createHeroElements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...heroElements]);

      setSelectedElement(heroElements[0]);
      setNewlyAddedElement(heroElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'hero-2') {
      const { elements: heroElements } = createHeroElements2(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...heroElements]);

      setSelectedElement(heroElements[0]);
      setNewlyAddedElement(heroElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'hero-3') {
      const { elements: heroElements } = createHeroElements3(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...heroElements]);

      setSelectedElement(heroElements[0]);
      setNewlyAddedElement(heroElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'hero-4') {
      const { elements: heroElements } = createHeroElements4(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...heroElements]);

      setSelectedElement(heroElements[0]);
      setNewlyAddedElement(heroElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'hero-5') {
      const { elements: heroElements } = createHeroElements5(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...heroElements]);

      setSelectedElement(heroElements[0]);
      setNewlyAddedElement(heroElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'hero-6') {
      const { elements: heroElements } = createHeroElements6(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...heroElements]);

      setSelectedElement(heroElements[0]);
      setNewlyAddedElement(heroElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'hero-7') {
      const { elements: heroElements } = createHeroElements7(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...heroElements]);

      setSelectedElement(heroElements[0]);
      setNewlyAddedElement(heroElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'checkout-1') {
      const { elements: checkoutElements } = createCheckoutElements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...checkoutElements]);

      setSelectedElement(checkoutElements[0]);
      setNewlyAddedElement(checkoutElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'navbar-1') {
      const { elements: navbarElements } = createNavbarElements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...navbarElements]);

      setSelectedElement(navbarElements[0]);
      setNewlyAddedElement(navbarElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'navbar-2') {
      const { elements: navbarElements } = createNavbarElements2(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...navbarElements]);

      setSelectedElement(navbarElements[0]);
      setNewlyAddedElement(navbarElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'navbar-3') {
      const { elements: navbarElements } = createNavbarElements3(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...navbarElements]);

      setSelectedElement(navbarElements[0]);
      setNewlyAddedElement(navbarElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'footer-1') {
      const { elements: footerElements } = createFooterElements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...footerElements]);

      setSelectedElement(footerElements[0]);
      setNewlyAddedElement(footerElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'footer-2') {
      const { elements: footerElements } = createFooterElements2(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...footerElements]);

      setSelectedElement(footerElements[0]);
      setNewlyAddedElement(footerElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'footer-3') {
      const { elements: footerElements } = createFooterElements3(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...footerElements]);

      setSelectedElement(footerElements[0]);
      setNewlyAddedElement(footerElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'footer-4') {
      const { elements: footerElements } = createFooterElements4(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...footerElements]);

      setSelectedElement(footerElements[0]);
      setNewlyAddedElement(footerElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'pricing-1') {
      const { elements: pricingElements } = createPricingElements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...pricingElements]);

      setSelectedElement(pricingElements[0]);
      setNewlyAddedElement(pricingElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'pricing-2') {
      const { elements: pricingElements } = createPricingElements2(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...pricingElements]);

      setSelectedElement(pricingElements[0]);
      setNewlyAddedElement(pricingElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'pricing-3') {
      const { elements: pricingElements } = createPricingElements3(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...pricingElements]);

      setSelectedElement(pricingElements[0]);
      setNewlyAddedElement(pricingElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'pricing-4') {
      const { elements: pricingElements } = createPricingElements4(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...pricingElements]);

      setSelectedElement(pricingElements[0]);
      setNewlyAddedElement(pricingElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'features-1') {
      const { elements: featuresElements } = createFeaturesElements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...featuresElements]);

      setSelectedElement(featuresElements[0]);
      setNewlyAddedElement(featuresElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'features-2') {
      const { elements: featuresElements } = createFeaturesElements2(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...featuresElements]);

      setSelectedElement(featuresElements[0]);
      setNewlyAddedElement(featuresElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'faq-1') {
      const { elements: faqElements } = createFaqElements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...faqElements]);

      setSelectedElement(faqElements[0]);
      setNewlyAddedElement(faqElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'faq-2') {
      const { elements: faqElements } = createFaqElements2(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...faqElements]);

      setSelectedElement(faqElements[0]);
      setNewlyAddedElement(faqElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'faq-3') {
      const { elements: faqElements } = createFaqElements3(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...faqElements]);

      setSelectedElement(faqElements[0]);
      setNewlyAddedElement(faqElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'blog-1') {
      const { elements: blogElements } = createBlogElements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...blogElements]);

      setSelectedElement(blogElements[0]);
      setNewlyAddedElement(blogElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'blog-2') {
      const { elements: blogElements } = createBlog2Elements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...blogElements]);

      setSelectedElement(blogElements[0]);
      setNewlyAddedElement(blogElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'blog-3') {
      const { elements: blogElements } = createBlog3Elements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...blogElements]);

      setSelectedElement(blogElements[0]);
      setNewlyAddedElement(blogElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'team-1') {
      const { elements: teamElements } = createTeamElements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...teamElements]);

      setSelectedElement(teamElements[0]);
      setNewlyAddedElement(teamElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'team-2') {
      const { elements: teamElements } = createTeamElements2(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...teamElements]);

      setSelectedElement(teamElements[0]);
      setNewlyAddedElement(teamElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'team-3') {
      const { elements: teamElements } = createTeam3Elements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...teamElements]);

      setSelectedElement(teamElements[0]);
      setNewlyAddedElement(teamElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'testimonials-1') {
      const { elements: testimonialElements } = createTestimonialElements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...testimonialElements]);

      setSelectedElement(testimonialElements[0]);
      setNewlyAddedElement(testimonialElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'testimonials-2') {
      const { elements: testimonialElements } = createTestimonialElements2(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...testimonialElements]);

      setSelectedElement(testimonialElements[0]);
      setNewlyAddedElement(testimonialElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'contact-1') {
      const { elements: contactElements } = createContactElements(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...contactElements]);

      setSelectedElement(contactElements[0]);
      setNewlyAddedElement(contactElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else if (section.sectionType === 'contact-2') {
      const { elements: contactElements } = createContactElements2(
        getHierarchyName,
        currentPageId,
        setClassStylesRegistry,
        setGlobalClassNames
      );
      
      setElements(prevElements => [...prevElements, ...contactElements]);

      setSelectedElement(contactElements[0]);
      setNewlyAddedElement(contactElements[0]);
      
      showNotification(`Added ${section.name} to the page`, "success");
      
      setShowSectionsSidebar(false);
    } else {
      showNotification(`Section type ${section.sectionType} not implemented yet`, "info");
    }
  };

  const getCategoryIcon = (category) => {
    const iconMap = {
      'Headers': 'heading',
      'Heroes': 'image',
      'Features': 'th-large',
      'Testimonials': 'quote-right',
      'Pricing': 'tag',
      'Contact': 'envelope',
      'Footers': 'shoe-prints',
      'Commerce': 'shopping-cart',
      'FAQ': 'question-circle',
      'Blog': 'blog',
      'Team': 'users'
    };
    return iconMap[category] || 'puzzle-piece';
  };

  const getSectionsByCategory = (category) => {
    const sectionMap = {
      'Heroes': [
        {
          id: 'hero-1',
          name: 'Hero Section 1',
          thumbnail: 'https://via.placeholder.com/250x120?text=Modern+Hero',
          sectionType: 'hero-1'
        },
        {
          id: 'hero-2',
          name: 'Hero Section 2',
          thumbnail: 'https://via.placeholder.com/250x120?text=Hero+With+Stats',
          sectionType: 'hero-2'
        },
        {
          id: 'hero-3',
          name: 'Hero Section 3',
          thumbnail: 'https://via.placeholder.com/250x120?text=Premium+Hero+Layout',
          sectionType: 'hero-3'
        },
        {
          id: 'hero-4',
          name: 'Hero Section 4',
          thumbnail: 'https://via.placeholder.com/250x120?text=Centered+Modern+Hero',
          sectionType: 'hero-4'
        },
        {
          id: 'hero-5',
          name: 'Hero Section 5',
          thumbnail: 'https://via.placeholder.com/250x120?text=AI+Split+Hero',
          sectionType: 'hero-5'
        },
        {
          id: 'hero-6',
          name: 'Hero Section 6',
          thumbnail: 'https://via.placeholder.com/250x120?text=Collaborate+Hero',
          sectionType: 'hero-6'
        },
        {
          id: 'hero-7',
          name: 'Hero Section 7',
          thumbnail: 'https://via.placeholder.com/250x120?text=AI+Chat+Hero',
          sectionType: 'hero-7'
        }
      ],
      'Headers': [
        {
          id: 'navbar-1',
          name: 'Navigation Bar 1',
          thumbnail: 'https://via.placeholder.com/250x120?text=Navbar+With+Submenu',
          sectionType: 'navbar-1'
        },
        {
          id: 'navbar-2',
          name: 'Navigation Bar 2',
          thumbnail: 'https://via.placeholder.com/250x120?text=Modern+Navbar+With+CTA',
          sectionType: 'navbar-2'
        },
        {
          id: 'navbar-3',
          name: 'Navigation Bar 3',
          thumbnail: 'https://via.placeholder.com/250x120?text=Navbar+With+TopBar',
          sectionType: 'navbar-3'
        },
        ...Array(2).fill().map((_, i) => ({
          id: `header-${i+2}`,
          name: `Header ${i+2}`,
          thumbnail: `https://via.placeholder.com/250x120?text=Header+${i+2}`,
          sectionType: `header-${i+2}`
        }))
      ],
      'Features': [
        {
          id: 'features-1',
          name: 'Features Cards',
          thumbnail: 'https://via.placeholder.com/250x120?text=Features+Cards',
          sectionType: 'features-1'
        },
        {
          id: 'features-2',
          name: 'Advanced Features with Tabs',
          thumbnail: 'https://via.placeholder.com/250x120?text=Advanced+Features',
          sectionType: 'features-2'
        },
        ...Array(2).fill().map((_, i) => ({
          id: `features-${i+3}`,
          name: `Features ${i+3}`,
          thumbnail: `https://via.placeholder.com/250x120?text=Features+${i+3}`,
          sectionType: `features-${i+3}`
        }))
      ],
      'Testimonials': [
        {
          id: 'testimonials-1',
          name: 'Testimonial Slider',
          thumbnail: 'https://via.placeholder.com/250x120?text=Testimonial+Slider',
          sectionType: 'testimonials-1'
        },
        {
          id: 'testimonials-2',
          name: 'Testimonials Grid',
          thumbnail: 'https://via.placeholder.com/250x120?text=Testimonials+Grid',
          sectionType: 'testimonials-2'
        }
      ],
      'Pricing': [
        {
          id: 'pricing-1',
          name: 'Pricing Plans 1',
          thumbnail: 'https://via.placeholder.com/250x120?text=Pricing+Cards',
          sectionType: 'pricing-1'
        },
        {
          id: 'pricing-2',
          name: 'Pricing Plans 2',
          thumbnail: 'https://via.placeholder.com/250x120?text=Pricing+Comparison+Table',
          sectionType: 'pricing-2'
        },
        {
          id: 'pricing-3',
          name: 'Pricing Plans 3',
          thumbnail: 'https://via.placeholder.com/250x120?text=Pricing+Table+Template',
          sectionType: 'pricing-3'
        },
        {
          id: 'pricing-4',
          name: 'Logo Design Pricing',
          thumbnail: 'https://via.placeholder.com/250x120?text=Logo+Design+Pricing',
          sectionType: 'pricing-4'
        }
      ],
      'Contact': [
        {
          id: 'contact-1',
          name: 'Contact 1',
          thumbnail: 'https://via.placeholder.com/250x120?text=Contact+1',
          sectionType: 'contact-1'
        },
        {
          id: 'contact-2',
          name: 'Contact 2',
          thumbnail: 'https://via.placeholder.com/250x120?text=Contact+2',
          sectionType: 'contact-2'
        }
      ],
      'Footers': [
        {
          id: 'footer-1',
          name: 'Footer 1',
          thumbnail: 'https://via.placeholder.com/250x120?text=Multi+Column+Footer',
          sectionType: 'footer-1'
        },
        {
          id: 'footer-2',
          name: 'Footer 2',
          thumbnail: 'https://via.placeholder.com/250x120?text=Minimalist+Footer',
          sectionType: 'footer-2'
        },
        {
          id: 'footer-3',
          name: 'Footer 3',
          thumbnail: 'https://via.placeholder.com/250x120?text=Split+Layout+Footer',
          sectionType: 'footer-3'
        },
        {
          id: 'footer-4',
          name: 'Footer 4',
          thumbnail: 'https://via.placeholder.com/250x120?text=Dark+Modern+Footer',
          sectionType: 'footer-4'
        }
      ],
      'Commerce': [
        {
          id: 'checkout-1',
          name: 'Checkout Page',
          thumbnail: 'https://via.placeholder.com/250x120?text=Checkout+Page',
          sectionType: 'checkout-1'
        }
      ],
      'FAQ': [
        {
          id: 'faq-1',
          name: 'FAQ Accordion',
          thumbnail: 'https://via.placeholder.com/250x120?text=FAQ+Accordion',
          sectionType: 'faq-1'
        },
        {
          id: 'faq-2',
          name: 'FAQ Tabs',
          thumbnail: 'https://via.placeholder.com/250x120?text=FAQ+With+Tabs',
          sectionType: 'faq-2'
        },
        {
          id: 'faq-3',
          name: 'FAQ Cards',
          thumbnail: 'https://via.placeholder.com/250x120?text=FAQ+Cards+Layout',
          sectionType: 'faq-3'
        }
      ],
      'Blog': [
        {
          id: 'blog-1',
          name: 'Blog List',
          thumbnail: 'https://via.placeholder.com/250x120?text=Blog+List',
          sectionType: 'blog-1'
        },
        {
          id: 'blog-2',
          name: 'Blog Layout 2',
          thumbnail: 'https://via.placeholder.com/250x120?text=Blog+Layout+2',
          sectionType: 'blog-2'
        },
        {
          id: 'blog-3',
          name: 'Blog Layout 3',
          thumbnail: 'https://via.placeholder.com/250x120?text=Blog+Layout+3',
          sectionType: 'blog-3'
        }
      ],
      'Team': [
        {
          id: 'team-1',
          name: 'Team Members',
          thumbnail: 'https://via.placeholder.com/250x120?text=Team+Members',
          sectionType: 'team-1'
        },
        {
          id: 'team-2',
          name: 'Team Grid',
          thumbnail: 'https://via.placeholder.com/250x120?text=Team+Grid',
          sectionType: 'team-2'
        },
        {
          id: 'team-3',
          name: 'Modern Team Cards',
          thumbnail: 'https://via.placeholder.com/250x120?text=Modern+Team+Cards',
          sectionType: 'team-3'
        }
      ]
    };

    return sectionMap[category] || [];
  };

  return (
    <div className="sidebar sections-sidebar">
      <div className="sidebar-header">
        {selectedCategory ? (
          <>
            <button className="back-button" onClick={() => setSelectedCategory(null)}>
              <i className="fas fa-arrow-left"></i>
            </button>
            <h3>{selectedCategory}</h3>
          </>
        ) : (
          <h3>Premade Sections</h3>
        )}
        <button className="close-btn" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>
      
      <div className="sidebar-content">
        {!selectedCategory ? (
          <div className="section-categories">
            {['Headers', 'Heroes', 'Features', 'FAQ', 'Blog', 'Team', 'Testimonials', 'Pricing', 'Contact', 'Footers', 'Commerce'].map(category => (
              <div 
                key={category} 
                className="section-category-item"
                onClick={() => setSelectedCategory(category)}
              >
                <div className="category-icon">
                  <i className={`fas fa-${getCategoryIcon(category)}`}></i>
                </div>
                <div className="category-name">{category}</div>
                <i className="fas fa-chevron-right"></i>
              </div>
            ))}
          </div>
        ) : (
          <div className="section-items">
            {getSectionsByCategory(selectedCategory).map(section => (
              <div 
                key={section.id}
                className="section-item"
                onClick={() => handleSectionSelect(section)}
              >
                <div className="section-preview">
                  <img src={section.thumbnail} alt={section.name} />
                </div>
                <div className="section-info">
                  <h4>{section.name}</h4>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionsSidebar; 